@use '../../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 140px;
  position: relative;
}

.card {
  width: 120px;
  height: 80px;
  border-radius: 10px;
  position: absolute;
}

.blue {
  animation: slideLeft 1s infinite alternate ease-in-out;
  .magnetic-strip {
    background-color: #000;
    margin-top: 10px;
    width: 100%;
    height: 16px;
  }
  .logo-hologram {
    height: 16px;
    width: 30px;
    border-radius: 10px;
    background-color: #c0c0c0;
    margin-top: 10px;
    margin-left: 10px;
  }
  .card-number {
    color: #c0c0c0;
    font-size: 8px;
    margin-top: 4px;
    margin-left: 10px;
    transform: scaleX(-1);
  }
  .card-validity {
    color: #c0c0c0;
    font-size: 4px;
    margin-top: 2px;
    margin-left: 10px;
  }
}

.yellow {
  animation: slideRight 1s infinite alternate ease-in-out;
  top: 50px;
  .logo {
    height: 8px;
    width: 30px;
    background-color: #c0c0c0;
    margin-top: 4px;
    margin-left: 4px;
  }
  .chip {
    height: 18px;
    width: 26px;
    border-radius: 2px;
    background-color: #c0c0c0;
    margin-top: 10px;
    margin-left: 10px;
  }
  .card-number {
    color: #c0c0c0;
    font-size: 8px;
    margin-top: 4px;
    margin-left: 10px;
  }
}

@keyframes slideLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-30px);
  }
}

@keyframes slideRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(30px);
  }
}
